<div class="container">
    <div class="section-header">
      <h2>¿Cuándo Estamos Abiertos?</h2>
      <div class="divider"></div>
    </div>
  
    <div>
      <div style="display: flex; gap: 2rem; flex-direction: column;">
        <p-card header="" *ngFor="let day of ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']">
          <div class="card-content">
            <div style="width: 120px; display: flex; align-items: center; gap: 0.5rem;">
              <p style="margin: 0;"><strong>{{ day }}</strong></p>
              <p-tag *ngIf="today === day" severity="info" value="Hoy"></p-tag>
            </div>
            <div class="flex gap-6">
                <div class="flex flex-column gap-2">
                    <p class="font-semibold">HORARIO MAÑANA</p>
                    <p>12:00 a 18:00</p>
                  </div>
                  <div class="flex flex-column gap-2">
                    <p class="font-semibold">HORARIO TARDE</p>
                    <p>20:00 a 00:00</p>
                  </div>
            </div>

          </div>
        </p-card>
      </div>
    </div>
  </div>
  